import script from "/app/pages/Users/edit_user.vue?type=script";
import "/app/pages/Users/edit_user.vue?type=style";
import { render } from "/app/pages/Users/edit_user.vue?type=template";
script.render = render;
export default script;
